import { t } from '@lingui/core/macro';
import { CourseKindSchema, CourseKind } from '@duke-hq/svc-api-db/schemas/enums/CourseKind.schema';
import {
  QualificationKindSchema,
  type QualificationKind,
} from '@duke-hq/svc-api-db/schemas/enums/QualificationKind.schema';

const courseKindLabels: Record<CourseKind, () => string> = {
  [CourseKindSchema.enum.QUALIFICATION]: () => t`Qualification`,
  [CourseKindSchema.enum.SKILL_SET]: () => t`Skill set`,
  [CourseKindSchema.enum.NON_VOCATIONAL]: () => t`Non-vocational`,
  [CourseKindSchema.enum.SHORT_COURSE]: () => t`Short course`,
};

const qualificationKindLabels: Record<QualificationKind, () => string> = {
  [QualificationKindSchema.enum.CERT_II]: () => t`Certificate II`,
  [QualificationKindSchema.enum.CERT_III]: () => t`Certificate III`,
  [QualificationKindSchema.enum.CERT_IV]: () => t`Certificate IV`,
};

export function getCourseKindLabel(kind: CourseKind): string {
  return courseKindLabels[kind]();
}

export function getCourseKinds() {
  return Object.entries(courseKindLabels).map(([value, getLabel]) => ({
    label: getLabel(),
    value,
  }));
}

export function getQualificationKinds() {
  return Object.entries(qualificationKindLabels).map(([value, getLabel]) => ({
    label: getLabel(),
    value,
  }));
}
